import React from 'react';
import PropTypes from 'prop-types';


const Icon = ({ name, className, title, size }) => (
  <i title={title} style={{ fontSize: size ? `${size}px` : 'inherit' }} className={`icon-${name} ${className}`} />
);

Icon.propTypes = {
  name: PropTypes.oneOf([
    'caret-down',
    'caret-left',
    'caret-right',
    'caret-up',
    'angle-down',
    'angle-left',
    'angle-right',
    'angle-up',
    'account-outline',
    'account',
    'wallet',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'refresh',
    'check',
    'copy',
    'card',
    'cross',
    'plus',
    'dashboard-outline',
    'dashboard',
    'delete',
    'warning',
    'message',
    'security-off',
    'security-on',
    'settings-outline',
    'settings',
    'inprogress-circle-outline',
    'check-circle-outline',
    'plus-circle-outline',
    'info-circle-outline',
    'history',
    'wallets',
    'ellipse',
    'payment-channel',
  ]).isRequired,
  /** Icon color */
  className: PropTypes.string,
  /** Icon title */
  title: PropTypes.string,
  /** Icon size */
  size: PropTypes.number,
};

Icon.defaultProps = {
  className: '',
  title: '',
  size: 0,
};

export { Icon };
